import type {
  AllExteriorTrimViewNoteTable,
  AwningViewNoteTable,
  ColumnViewNoteTable,
  DoorViewNoteTable,
  ExteriorDoorCasingViewNoteTable,
  ExteriorWindowCasingViewNoteTable,
  PorchTrimViewNoteTable,
  PorchViewNoteTable,
  PropViewNoteTable,
  RailingViewNoteTable,
  ShutterViewNoteTable,
  WainscotingViewNoteTable,
  WindowViewNoteTable,
} from "building-types/settings/viewNotesSettings";
import {
  AwningViewNoteType,
  ColumnViewNoteType,
  DoorViewNoteType,
  ExteriorDoorCasingViewNoteType,
  ExteriorTrimViewNoteType,
  ExteriorWindowCasingViewNoteType,
  PorchTrimViewNoteType,
  PorchViewNoteType,
  PropViewNoteType,
  RailingViewNoteType,
  ShutterViewNoteTypes,
  WainscotingViewNoteType,
  WindowViewNoteType,
} from "building-types/settings/viewNotesSettings";
import { defaultEmptyViewNote } from "building-types/views/viewNotes";

// SETTINGS-ORIGINATED

export const defaultAwningViewNotes: AwningViewNoteTable = {
  [AwningViewNoteType.AWNING]: defaultEmptyViewNote,
  [AwningViewNoteType.BRACKET]: defaultEmptyViewNote,
};

export const defaultExteriorDoorCasingViewNotes: ExteriorDoorCasingViewNoteTable = {
  [ExteriorDoorCasingViewNoteType.APRON]: defaultEmptyViewNote,
  [ExteriorDoorCasingViewNoteType.HEAD]: defaultEmptyViewNote,
  [ExteriorDoorCasingViewNoteType.SIDE]: defaultEmptyViewNote,
};

export const defaultExteriorWindowCasingViewNotes: ExteriorWindowCasingViewNoteTable = {
  [ExteriorWindowCasingViewNoteType.APRON]: defaultEmptyViewNote,
  [ExteriorWindowCasingViewNoteType.HEAD]: defaultEmptyViewNote,
  [ExteriorWindowCasingViewNoteType.SIDE]: defaultEmptyViewNote,
  [ExteriorWindowCasingViewNoteType.STOOL]: defaultEmptyViewNote,
};

export const defaultShutterViewNotes: ShutterViewNoteTable = {
  [ShutterViewNoteTypes.SHUTTER]: defaultEmptyViewNote,
};

export const defaultPorchViewNotes: PorchViewNoteTable = {
  [PorchViewNoteType.COLUMN_BRACKET]: defaultEmptyViewNote,
  [PorchViewNoteType.PORCH_HEADER]: defaultEmptyViewNote,
  [PorchViewNoteType.PORCH_RAILING]: defaultEmptyViewNote,
};

export const defaultPorchTrimViewNotes: PorchTrimViewNoteTable = {
  [PorchTrimViewNoteType.PORCH_HEADER_TRIM]: defaultEmptyViewNote,
};

export const defaultRailingViewNotes: RailingViewNoteTable = {
  [RailingViewNoteType.RAILING]: defaultEmptyViewNote,
};

export const defaultColumnViewNotes: ColumnViewNoteTable = {
  [ColumnViewNoteType.COLUMN]: defaultEmptyViewNote,
};

export const defaultWainscotingViewNotes: WainscotingViewNoteTable = {
  [WainscotingViewNoteType.WAINSCOTING]: defaultEmptyViewNote,
  [WainscotingViewNoteType.CAP]: defaultEmptyViewNote,
};

const defaultCornerBoardNote = {
  enable: true,
  text: "CORNERBOARD",
  tagOnlyOne: true,
};

export const defaultAllExteriorTrimViewNotes: AllExteriorTrimViewNoteTable = {
  ...{
    [ExteriorTrimViewNoteType.OUTSIDE_CORNER]: defaultCornerBoardNote,
    [ExteriorTrimViewNoteType.INSIDE_CORNER]: defaultEmptyViewNote,
    [ExteriorTrimViewNoteType.DORMER_CORNER]: defaultEmptyViewNote,
    [ExteriorTrimViewNoteType.WALL_ROOF_BASEBOARD]: defaultEmptyViewNote,
    [PorchTrimViewNoteType.PORCH_HEADER_TRIM]: defaultEmptyViewNote,
  },
};

//for catalog-type settings
export const defaultWindowViewNotes: WindowViewNoteTable = {
  [WindowViewNoteType.WINDOW]: defaultEmptyViewNote,
};

export const defaultDoorViewNotes: DoorViewNoteTable = {
  [DoorViewNoteType.DOOR]: defaultEmptyViewNote,
};

export const defaultPropViewNotes: PropViewNoteTable = {
  [PropViewNoteType.PROP]: defaultEmptyViewNote,
};
